interface InsuranceCardProps {
  firstLabel: string;
  firstLabelValue: string;
  secondLabel: string;
  secondLabelValue: string;
  planType?: string;
}

export const InsuranceCard = ({
  firstLabel,
  firstLabelValue,
  secondLabel,
  secondLabelValue,
  planType,
}: InsuranceCardProps) => {
  return (
    <div className="flex w-full flex-col gap-2 rounded-xl bg-primary-50 p-4 font-medium">
      <div className="flex justify-between">
        <p className="text-primary-900">{firstLabel}</p>
        <div className="flex min-w-0 items-center gap-2">
          {planType && (
            <div className="rounded-xl border border-neutral-100 bg-white px-1 py-0.5">
              <p className="font-medium text-primary-950">{planType}</p>
            </div>
          )}
          <p className="truncate text-right text-neutral-500">
            {firstLabelValue}
          </p>
        </div>
      </div>
      <div className="flex justify-between">
        <p className="text-primary-900">{secondLabel}</p>
        <p className="text-neutral-500">{secondLabelValue}</p>
      </div>
    </div>
  );
};
